import VideoPlayer from './VideoPlayer';
import CardContainer from './CardContainer';

interface RevealEvolutionVideoCardProps {
  videoSrc: string;
  onEnded: VoidFunction;
}

const RevealEvolutionVideoCard: React.FC<RevealEvolutionVideoCardProps> = ({ videoSrc, onEnded }: RevealEvolutionVideoCardProps) => {
  return (
    <CardContainer hasBlueBorder>
      <div className='flex-1 overflow-hidden'>
        <VideoPlayer src={videoSrc} loop={false} onEnded={onEnded} className='w-full h-full object-contain' />
      </div>
    </CardContainer>
  );
};

export default RevealEvolutionVideoCard;
